<app-header [heroImg]='img'></app-header>
  <div> 
    <router-outlet></router-outlet>
  </div>
  <div class="child4" style="background-color:#38525c;">
    <app-footer></app-footer>
  </div>
